import type { Card } from '../types';
import { Group, Rect, Text } from 'react-konva';

interface HandCardsProps {
  cards: Card[];
  selectedCards: Card[];
  onSelect: (card: Card) => void;
  x: number;
  y: number;
}

const CARD_WIDTH = 60;
const CARD_HEIGHT = 84;
const CARD_SPACING = 65;

export function HandCards({ cards, selectedCards, onSelect, x, y }: HandCardsProps) {
  const totalWidth = cards.length * CARD_SPACING;
  const startX = x - totalWidth / 2 + CARD_SPACING / 2;

  const sortedCards = [...cards].sort((a, b) => b.valueNum - a.valueNum);

  return (
    <>
      {sortedCards.map((card, index) => {
        const isSelected = selectedCards.some(c => c.id === card.id);
        const cardX = startX + index * CARD_SPACING;
        const cardY = y + (isSelected ? -15 : 0);

        return (
          <Group
            key={card.id}
            x={cardX}
            y={cardY}
            onClick={() => onSelect(card)}
          >
            <CardRect card={card} selected={isSelected} />
          </Group>
        );
      })}
    </>
  );
}

function CardRect({ card, selected }: { card: Card; selected: boolean }) {
  const isRedSuit = card.suit === '♥' || card.suit === '♦';
  const suitColor = isRedSuit ? '#e74c3c' : '#2c3e50';
  const isRed = card.suit === '♥' && card.isRedHeart;

  return (
    <>
      <Rect
        width={CARD_WIDTH}
        height={CARD_HEIGHT}
        fill={selected ? '#ffeb3b' : '#fff'}
        stroke={selected ? '#f39c12' : '#ddd'}
        strokeWidth={selected ? 3 : 1}
        cornerRadius={6}
        shadowColor="black"
        shadowBlur={selected ? 10 : 3}
        shadowOpacity={0.3}
      />
      <Text
        x={4}
        y={4}
        text={card.value}
        fontSize={14}
        fontStyle="bold"
        fill={isRed ? '#e74c3c' : suitColor}
      />
      <Text
        x={4}
        y={20}
        text={card.suit || 'Joker'}
        fontSize={16}
        fill={suitColor}
      />
      <Text
        x={CARD_WIDTH / 2}
        y={CARD_HEIGHT / 2}
        text={card.suit || ''}
        fontSize={24}
        fill={suitColor}
        offsetX={CARD_WIDTH / 4}
        offsetY={12}
      />
    </>
  );
}